module.exports = __webpack_public_path__ + "img/sparkle-1.b2842acd.svg";